"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LinkCopied = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var prop_types_1 = tslib_1.__importDefault(require("prop-types"));
var link_copied_1 = require("./link-copied/link-copied");
Object.defineProperty(exports, "LinkCopied", { enumerable: true, get: function () { return tslib_1.__importDefault(link_copied_1).default; } });
var tooltip_1 = tslib_1.__importDefault(require("../../../../ui-components/tooltip/tooltip"));
var inline_icon_1 = tslib_1.__importDefault(require("../../../../ui-components/inline-icon/inline-icon"));
var LinkIcon_1 = tslib_1.__importDefault(require("../../../../../icons/compiled/components/LinkIcon"));
var styles_scss_1 = tslib_1.__importDefault(require("../styles.scss"));
var styles_scss_2 = tslib_1.__importDefault(require("./styles.scss"));
var Link = /** @class */ (function (_super) {
    tslib_1.__extends(Link, _super);
    function Link() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.handleClick = function () {
            var canShareContent = _this.props.canShareContent;
            if (canShareContent) {
                _this.copyToClipboard();
            }
            _this.props.onClick();
        };
        _this.saveRef = function (ref) {
            _this.ref = ref;
        };
        return _this;
    }
    Link.prototype.copyToClipboard = function () {
        if (document.queryCommandSupported('copy')) {
            this.ref.select();
            document.execCommand('copy');
        }
    };
    Link.prototype.render = function () {
        var _a = this.props, dataHook = _a.dataHook, className = _a.className, ariaLabel = _a.ariaLabel, instanceInfo = _a.instanceInfo, tooltip = _a.tooltip;
        return (react_1.default.createElement(tooltip_1.default, { content: tooltip },
            react_1.default.createElement("button", { className: className, "data-hook": dataHook, onClick: this.handleClick, "aria-label": ariaLabel },
                react_1.default.createElement(inline_icon_1.default, { icon: react_1.default.createElement(LinkIcon_1.default, null), className: styles_scss_1.default.icon }),
                instanceInfo && (react_1.default.createElement("input", { type: "text", ref: this.saveRef, tabIndex: "-1", readOnly: true, className: styles_scss_2.default.utilityInput, value: instanceInfo.siteUrl })))));
    };
    Link.propTypes = {
        dataHook: prop_types_1.default.string,
        onClick: prop_types_1.default.func,
        className: prop_types_1.default.string,
        tooltip: prop_types_1.default.node,
        canShareContent: prop_types_1.default.bool,
        ariaLabel: prop_types_1.default.string,
        instanceInfo: prop_types_1.default.shape({
            instanceId: prop_types_1.default.string,
            componentId: prop_types_1.default.string,
            sitePageId: prop_types_1.default.string,
            siteUrl: prop_types_1.default.string,
        }),
    };
    return Link;
}(react_1.default.Component));
exports.default = Link;
//# sourceMappingURL=link.js.map